<script setup>
import { onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import PlaylistsGridBlock from '@components/playlists/playlists-grid-block'

const featuredCharts = ref([])

onMounted(() => {
    DataLayer.playlists.getByType({ type: 'chart', offset: 0, limit: 6, featued: 1 }).then(response => {
        featuredCharts.value = response.body.filter(playlist => playlist.revisions_id !== null)
    })
})
</script>

<template>
    <div v-if="featuredCharts && featuredCharts.length">
        <BaseSection
            :show-all-link="{ name: 'browse/charts/index' }"
            title="Featured Charts"
            show-all-title="Browse More"
        >
            <PlaylistsGridBlock
                :playlists="featuredCharts"
                type="charts"
                min-tile-width="160px"
            />
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

</style>
